import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingContext, M_Table, M_StateActions } from '../M_Components'
import { useDispatch } from 'react-redux'

export default function CreateChangeLog({ roles, onCreateTab }) {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const [refresh, setRefresh] = useState(false)
    const ctx = useContext(LoadingContext)
    const removeContextItems = ['Print', 'Copy', 'View']

    const NewRoute = (url, label, operation, data) => {
        dispatch(M_StateActions.addM_State({ key: 'operation', value: operation }))
        if (operation === 'Edit' || operation === 'Copy' || operation === 'View') {
            if (!data) {
                ctx.toastMessages('error', '', t("SelectedLine"))
                return
            }
            dispatch(M_StateActions.addM_State({ key: 'ChangeLogLine', value: data }))
        }
        if (operation === 'Create') {
            onCreateTab(url, label)
        }
        else if (operation === 'Edit' || operation === 'Copy' || operation === 'View') {
            onCreateTab(url, `${label} "${data.Version}"`)
        }
    }

    return (
        <div className="divGlobalSettings">
            <div className="subTitleSettings">
                <div>
                    <div style={{ color: ctx.secondaryColor }} >
                        {t("CreateChangeLog")}
                    </div>
                    <div className="labelSubtitleSettings" >
                        {t("InfoCreateChangeLog")}
                    </div>
                </div>
            </div>
            <div>
                <M_Table
                    entityName={'ChangeLog'}
                    filtersOnTable
                    rolePermissions={roles}
                    refresh={refresh}
                    setRefresh={setRefresh}
                    useSessionStorage={false}
                    removeContextItems={removeContextItems}
                    replaceFunctions={new Map([
                        ['Create', (e) => NewRoute("ChangeLogCrud", t("Add"), 'Create', e)],
                        ['Edit', (e) => NewRoute("ChangeLogCrud", t("Edit"), 'Edit', e)],
                    ])}
                />
            </div>
        </div>
    )
}